import { render } from "./PostCategorySearchCriteria.vue?vue&type=template&id=50964ab4"
import script from "./PostCategorySearchCriteria.vue?vue&type=script&lang=js"
export * from "./PostCategorySearchCriteria.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__